import { tagsFilterAtom } from 'atoms/filters/sim';
import { simTagsHintsAtom } from 'atoms/hints/sim';
import { TagsSearchFilter } from 'tags/Components/TagsSearchFilter';

export const TagsSearchInput = () => {
  return <TagsSearchFilter tagsFilterAtom={tagsFilterAtom} tagsHintsAtom={simTagsHintsAtom} />;
};
